import React from "react";
import { Entry, normalizeName } from "./ranking";

// Columns left to right: 2nd, 1st, 3rd (index into the ranking).
const PODIUM_ORDER = [1, 0, 2];

interface PodiumProps {
  ranked: Entry[];
  playerName: string;
  format: (value: number) => string;
  onRestart: () => void;
}

// End screen (mockup 2): top 3 plus the player's own place and result.
export default function Podium({ ranked, playerName, format, onRestart }: PodiumProps) {
  const playerIndex = ranked.findIndex((e) => normalizeName(e.name) === normalizeName(playerName));
  const player = ranked[playerIndex];

  return (
    <main className="ad-screen ad-finished">
      <h1 className="ad-banner plain">Leaderboard</h1>
      <ol className="ad-podium">
        {PODIUM_ORDER.map((index) => {
          const entry = ranked[index];
          return (
            <li key={index} className={`ad-podium-place place-${index + 1}`}>
              <span className="ad-podium-bar">{index + 1}</span>
              <span className="ad-podium-name">{entry?.name ?? " "}</span>
              <span className="ad-podium-value">{entry ? format(entry.value) : " "}</span>
            </li>
          );
        })}
      </ol>
      {player ? (
        <p className="ad-own-result">
          {player.name} · {playerIndex + 1}º lugar · {format(player.value)}
        </p>
      ) : null}
      <h2 className="ad-continue">O desafio continua!</h2>
      <button type="button" className="ad-pill" onClick={onRestart}>
        Recomeçar
      </button>
    </main>
  );
}
